<template>
  <transition name="notice-fade">
    <div class="youth-notice-mask" v-if="visible" @click.self="close">
      <div class="youth-notice-panel" :class="type">
        <div class="notice-icon">
          <span>{{ icon }}</span>
        </div>
        <h2 class="notice-title">{{ title }}</h2>
        <p class="notice-desc">{{ description }}</p>
        <button type="button" class="notice-btn" @click="close">知道了</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'YouthNoticeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'success' // success=开启(橙青渐变) / info=关闭(蓝绿渐变)
    }
  },
  emits: ['close'],
  computed: {
    icon() {
      return this.type === 'info' ? '✓' : '✓'
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.youth-notice-mask {
  position: fixed;
  inset: 0;
  z-index: 4000;
  display: grid;
  place-items: center;
  padding: 18px;
  background: rgba(3, 6, 12, 0.78);
  backdrop-filter: blur(8px);
}

.youth-notice-panel {
  position: relative;
  width: min(460px, 100%);
  padding: 34px 30px 30px;
  text-align: center;
  border-radius: 16px;
  color: #eef3ff;
  background:
    radial-gradient(circle at 50% 0%, rgba(255, 204, 102, 0.2), transparent 46%),
    linear-gradient(180deg, rgba(22, 27, 45, 0.99), rgba(9, 12, 22, 0.99));
  border: 2px solid transparent;
  background-clip: padding-box;
  box-shadow:
    0 0 0 2px rgba(255, 204, 102, 0.55),
    0 0 42px rgba(255, 204, 102, 0.28),
    0 40px 90px rgba(0, 0, 0, 0.55);
  animation: notice-pop 0.28s ease;
}

.youth-notice-panel.info {
  background:
    radial-gradient(circle at 50% 0%, rgba(35, 211, 238, 0.22), transparent 46%),
    linear-gradient(180deg, rgba(22, 27, 45, 0.99), rgba(9, 12, 22, 0.99));
  box-shadow:
    0 0 0 2px rgba(35, 211, 238, 0.55),
    0 0 42px rgba(35, 211, 238, 0.26),
    0 40px 90px rgba(0, 0, 0, 0.55);
}

.notice-icon {
  width: 84px;
  height: 84px;
  margin: 0 auto 18px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffcc66, #23d3ee);
  box-shadow: 0 0 0 8px rgba(255, 204, 102, 0.16), 0 0 34px rgba(255, 204, 102, 0.45);
}

.youth-notice-panel.info .notice-icon {
  background: linear-gradient(135deg, #23d3ee, #7ef0d4);
  box-shadow: 0 0 0 8px rgba(35, 211, 238, 0.16), 0 0 34px rgba(35, 211, 238, 0.45);
}

.notice-icon span {
  color: #07101d;
  font-size: 52px;
  font-weight: 900;
  line-height: 1;
}

.notice-title {
  margin: 0 0 12px;
  color: #f5f7ff;
  font-size: 30px;
  font-weight: 900;
  letter-spacing: 0.5px;
}

.notice-desc {
  margin: 0;
  color: #9faaca;
  font-size: 15px;
  line-height: 1.8;
}

.notice-btn {
  width: 100%;
  min-height: 48px;
  margin-top: 24px;
  border: 0;
  border-radius: 10px;
  color: #07101d;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 2px;
  cursor: pointer;
  background: linear-gradient(135deg, #ffcc66, #23d3ee);
  box-shadow: 0 16px 34px rgba(255, 204, 102, 0.24);
}

.notice-btn:hover {
  filter: brightness(1.08);
}

@keyframes notice-pop {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.notice-fade-enter-active {
  animation: notice-pop 0.28s ease;
}

.notice-fade-leave-active {
  transition: opacity 0.18s ease;
}

.notice-fade-leave-to {
  opacity: 0;
}
</style>
